import { getAnnouncementList } from '@/service/announcement'
import { useInterval } from 'ahooks'
import { useCallback, useEffect, useState } from 'react'

type Announcement = {
  content: string
  title: string
}

export function useAnnouncements() {
  const [announcements, setAnnoucements] = useState<Announcement[] | null>(null)
  const fetchAnnouncement = useCallback(async () => {
    const {
      data: { data = [] },
    } = await getAnnouncementList({ limit: 1, sort: 'id', order: 'desc' })
    setAnnoucements(data?.filter((i: { expired: any }) => !i.expired))
    return data
  }, [])

  useEffect(() => {
    fetchAnnouncement()
  }, [fetchAnnouncement])

  useInterval(() => {
    fetchAnnouncement()
  }, 60 * 1000)

  return announcements
}
